import { render, staticRenderFns } from "./ItemNetwork.vue?vue&type=template&id=3b8ddca0"
import script from "./ItemNetwork.vue?vue&type=script&lang=js"
export * from "./ItemNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports